import { observer } from 'mobx-react';
import { SelectTune } from './SelectTune';
import { SwitchTune } from './SwitchTune';
import { ResetTune } from './ResetTune';
import { SliderTune } from './SliderTune';
import { isResetTuneControl, isSingularTuneControl } from '@/components/contentContainers/entityValidators.ts';

import { TuneControlsKind } from '@/engine/app/interfaces';

import type { IPlanningEntityProps } from '@/components/common/interfaces.ts';
import type { TuneControlInfo } from '@/engine/app/models/viewEntity/view.entity.ts';
import type { FC } from 'react';

export const DeviceTunes: FC<IPlanningEntityProps<TuneControlInfo>> = observer(({ entity }) => {
  return (
    <>
      {isResetTuneControl(entity.descriptor) && entity.kind === TuneControlsKind.Reset && (
        <ResetTune descriptors={entity.descriptor} label={entity.label} key={'reset-tune' + entity.order} />
      )}
      {isSingularTuneControl(entity.descriptor) && entity.kind === TuneControlsKind.Select && (
        <SelectTune
          descriptor={entity.descriptor}
          disclaimer={entity.disclaimerType}
          label={entity.label}
          key={'select-tune' + entity.order}
        />
      )}

      {isSingularTuneControl(entity.descriptor) && entity.kind === TuneControlsKind.Switch && (
        <SwitchTune
          descriptor={entity.descriptor}
          disclaimer={entity.disclaimerType}
          label={entity.label}
          key={'select-tune' + entity.order}
        />
      )}
      {isSingularTuneControl(entity.descriptor) && entity.kind === TuneControlsKind.Stepper && (
        <SliderTune
          descriptor={entity.descriptor}
          label={entity.label}
          units={entity.units}
          subUnits={entity.subUnits}
          key={'slider-tune' + entity.order}
          throttleMs={30}
          locatableDescriptors={entity.locatableDescriptors}
          hasReset={entity.hasReset}
        />
      )}
    </>
  );
});
